// The full set of i18n namespaces, derived at build time from the reference
// language's files (a namespace IS the filename stem, per i18next.config.ts).
// Passed to i18next's `ns` so the active language's namespaces are all
// preloaded at init — GF-204, no raw keys for out-of-component t() calls. Add
// a namespace file and it is picked up here automatically; no manual
// maintenance.
//
// `import.meta.glob` (non-eager) only enumerates the matching paths at build
// time — it does not import the JSON, so no translations are pulled into this
// module.
export const NAMESPACES = Object.keys(import.meta.glob('./en/*.json')).map(
  (path) => path.replace('./en/', '').replace('.json', ''),
);

export type Namespace = string;
